module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAMAAACf4xmcAAAAS1BMVEUAAAA5ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez4l5thQAAAAGHRSTlMA4e0qUTWQ06xyWEvl49m5bvGheXhiGxkVcHteAAAAd0lEQVQ4y+3TSQ6AIAwF0GqdABVnuf9JNU2IJIA1blzIX7XlhVULKbHMfe6l9pQwgbQeq0Ms81hH8wFxokIjyhDL6FUBVFQ0ABhnhcNKjlXjE7aCMppl4uwk+9tO7cYwm8S+Y8qZ4N32XpGW8bfw9rJgCd7p73IA3H4Y09OY1x8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pageico_5.png
// module id = +i99
// module chunks = 1